<div class="d-flex flex-column align-items-center my-4">
    <adapt-display-seeds [seedType]="SeedEntity.Purpose"></adapt-display-seeds>

    <button *adaptIfAuthorised="CompassGuidingPhilosophyEdit"
            class="btn btn-primary px-4 mt-3"
            [adaptBlockingClick]="editOwnersWhy"
            role="button">Update owners' why</button>
</div>
